import { UPDATE_SEARCH_SUGGESTIONS } from '../action-list'

export const updateSearchSuggestions = (query, suggestions) => ({
  type: UPDATE_SEARCH_SUGGESTIONS,
  query,
  suggestions,
})
